import React, { useEffect, useState } from "react";
import "../CSS/CrownCss/CHomePage.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import loading_ from "../../Assets2/loading.gif";
import Store from "../../Store/Store";
import { set_current_dyn_pageName } from "../../Action/Action";
import axiosInstance from "../../services/axiosConfig";

const CHomePage = (props) => {
  const history = useHistory();
  const [redirecting, setRedirecting] = useState(false);

  // CompanyId > 2 ise SCADA Homepage'e yönlendir
  useEffect(() => {
    const companyId = parseInt(sessionStorage.getItem("TEMPCOM") || sessionStorage.getItem("ucer_id") || "0");

    if (companyId > 2 && !redirecting) {
      setRedirecting(true);
      console.log("🏠 CHomePage: CompanyId > 2, redirecting to SCADA Homepage...", companyId);

      axiosInstance.get(`/scada/pages/homepage/${companyId}`)
        .then(res => {
          const data = res.data;
          if (data && data.pageId) {
            console.log("🏠 SCADA Homepage found:", data.pageId);
            history.push(`/axisPreview/${data.pageId}`);
          } else {
            console.log("⚠️ No SCADA Homepage configured");
            setRedirecting(false);
          }
        })
        .catch(err => {
          console.log("⚠️ Could not fetch SCADA homepage:", err);
          // Don't reset redirecting to prevent infinite loop on 401 errors
        });
    }
  }, [history, redirecting]);

  const [pages, Set_Pages] = useState([]);
  const [vrf_control, Set_vrf_control] = useState([]);
  const [su_depoları, Set_su_depoları] = useState([]);
  const [enerji_izleme, Set_enerji_izleme] = useState([]);
  const [fanlar, Set_fanlar] = useState([]);
  const [sıcak_su, Set_sıcak_su] = useState([]);
  const [pompa_hidrofor, Set_pompa_hidrofor] = useState([]);
  const [page_mamagement, Set_page_mamagement] = useState([]);


  useEffect(() => {
    console.log(props.yetkilendirme_state, props.uid);

    props.users_list.forEach(x => {

      if (x.userId === props.uid && x.yetkilendirme) {
        console.log(x);
        let yetki_parse = JSON.parse(x.yetkilendirme)
        let com_id = props.temp_com_id || 2
        let is_objectExist = yetki_parse[com_id]
        console.log(is_objectExist);

        if (is_objectExist !== undefined) {
          Object.entries(is_objectExist).forEach(s => {
            if (s[0] === "VRF") {
              if (s[1].O === "t") {
                Set_vrf_control(true);
              } else {
                Set_vrf_control(false);
              }
            } else if (s[0] === "Sıcak Su") {
              if (s[1].O === "t") {
                Set_sıcak_su(true);
              } else {
                Set_sıcak_su(false);
              }
            } else if (s[0] === "Su Depoları") {
              if (s[1].O === "t") {
                Set_su_depoları(true);
              } else {
                Set_su_depoları(false);
              }
            } else if (s[0] === "Pompa/Hidrofor") {
              if (s[1].O === "t") {
                Set_pompa_hidrofor(true);
              } else {
                Set_pompa_hidrofor(false);
              }
            } else if (s[0] === "Fanlar") {
              if (s[1].O === "t") {
                Set_fanlar(true);
              } else {
                Set_fanlar(false);
              }
            } else if (s[0] === "Enerji İzleme") {
              if (s[1].O === "t") {
                Set_enerji_izleme(true);
              } else {
                Set_enerji_izleme(false);
              }
            }
            else if (s[0] === "Page_Management") {
              if (s[1].O === "t") {
                Set_page_mamagement(true);
              } else {
                Set_page_mamagement(false);
              }
            }
          });
        }

      }
    })
    console.log(props.uid);
  }, [props.uid, props.yetkilendirme_state]);

  useEffect(() => {
    if (props.pages && props.pages.length > 0) {
      console.warn(props.pages, "weüdfşaewüdşfwe")
      Set_Pages(props.pages);
    }
  }, [props.pages]);

  // Yönlendirme sırasında loading göster
  if (redirecting) {
    return (
      <main>
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column"
        }}>
          <img src={loading_} alt="loading" style={{ width: "50px" }} />
          <p style={{ marginTop: "10px", color: "#666" }}>Ana Ekran yükleniyor...</p>
        </div>
      </main>
    );
  }

  return (
    <main>
      <section style={{ height: "100%" }}>
        {props.tag_values &&
          (props.tag_values.length < 1 && props.pages.length<1 ? (
            <div
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              className="loading"
            >
              <img style={{ width: "15%" }} src={loading_} alt="" />
              <h5
                style={{
                  fontFamily: "sans-serif",
                  fontWeight: "600",
                  fontSize: "1.2em",
                  color: "rgb(40,30,40)",
                  marginTop: "30px",
                  fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                }}
              >
                Veriler Yükleniyor. Lütfen Bekleyiniz...
              </h5>
            </div>
          ) : (
            <div className="grid_display_bu">
              <div style={{ display: "grid" }} className="grid-display">
                {/*  <button>Isıtma Sistemleri</button>
              <button>Klima Sant. ve Hücreli Fanlar</button> */}

                {/* <button
                  disabled={sıcak_su === true ? false : true}
                  onClick={() => {
                    history.push("/kazan-dairesi-home");
                  }}
                >
                  KAZAN DAİRESİ
                </button>
                <button
                  disabled={vrf_control === true ? false : true}
                  onClick={() => {
                    history.push("/Sicak-su-sistemi");
                  }}
                >
                  SICAK SU SİSTEMİ
                </button>
                <button
                  disabled={pompa_hidrofor === true ? false : true}
                  onClick={() => {
                    history.push("/pompa-hidrofor");
                  }}
                >
                  POMPA VE HİDROFOR SİSTEMLERİ
                </button>
                <button
                  disabled={fanlar === true ? false : true}
                  onClick={() => {
                    history.push("/fanlar");
                  }}
                >
                  FANLAR
                </button>
                <button
                  disabled={enerji_izleme === true ? false : true}
                  onClick={() => {
                    history.push("/enerji-crown");
                  }}
                >
                  ENERJİ İZLEME{" "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/jenerator-home");
                  }}
                >
                  JENERATÖRLER{" "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/asansorler");
                  }}
                >
                  ASANSÖRLER{" "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/havuz-sistemi");
                  }}
                >
                  HAVUZ SİSTEMİ{" "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/crown-su-depolari");
                  }}
                >
                  SU DEPOLARI {"  "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/sogutma-sistemi");
                  }}
                >
                  SOĞUTMA SİSTEMİ{" "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/klima-santralleri");
                  }}
                >
                  KLİMA SANTRALLERİ{" "}
                </button> */}

                {props.pages.map((item, index) => {
                  if (item.group === "Ana Ekran") {
                    let x_;
                    props.users_list.forEach(x => {

                      if (x.userId === props.uid && x.yetkilendirme) {
                        let yetki_parse = JSON.parse(x.yetkilendirme)
                        let com_id = props.temp_com_id || 2
                        let is_objectExist = yetki_parse[com_id]
                        if (is_objectExist !== undefined) {

                          Object.entries(is_objectExist).forEach(s => {
                            if (s[0] === item.pageName) {
                              x_ = s[1].O
                            }
                          })
                        }
                      }
                    })

                    function normalizeURLPath(path) {
                      const turkishMap = {
                        'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                        'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                        'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                      };

                      return path.split('').map(char => turkishMap[char] || char).join('');
                    }

                    let pathName = normalizeURLPath(item.pageName);

                    return <button
                      disabled={x_ === "t" ? false : true}
                      onClick={async () => {
                        await Store.dispatch(set_current_dyn_pageName(item.pageName))
                        history.push("/pages/" + pathName.replaceAll(" ", "_"));
                      }}
                    >
                      {item.pageName.toUpperCase()} {" "}
                    </button>
                  }
                })}


              </div>
            </div>
          ))}
      </section>
    </main>
  );
};
const MapStateToProps = (state) => {
  return {
    pages: state.project_reducer.pages,
    tag_values: state.project_reducer.tag_values,
    group_id: state.project_reducer.group_id,
    uid: state.auth_reducer.user_id,
    temp_com_id: state.project_reducer.temp_com_id,
    users_list: state.project_reducer.users_list,


    yetkilendirme_state: state.project_reducer.yetkilendirme_state,
  };
};
export default connect(MapStateToProps)(CHomePage);
